/* app/js/src/components/channel/future-preview/future-preview.component.scss */
.flex {
  display: flex;
}
.flex.wrap {
  flex-wrap: wrap;
}
.flex.row {
  flex-direction: row;
}
.flex.column {
  flex-direction: column;
}
.flex.space-between {
  justify-content: space-between;
}
.flex.space-around {
  justify-content: space-around;
}
.flex.justify-center {
  justify-content: center;
}
.flex.justify-end {
  justify-content: end;
}
.flex.justify-evenly {
  justify-content: space-evenly;
}
.flex.align-items-center {
  align-items: center;
}
.flex.fill-width {
  width: 100%;
}
.flex.fill-height {
  height: 100%;
}
.flex.justify-end {
  justify-content: flex-end;
}
.flex.align-items-baseline {
  align-items: baseline;
}
.flex.red {
  background-color: red;
}
.flex.blue {
  background-color: blue;
}
:host {
  position: absolute;
  z-index: 22;
}
.container {
  position: absolute;
  transition: opacity ease-in 0.2s;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.2);
  transform: translate(32%, 50%);
  background-color: white;
}
.container evrideo-time-editor {
  margin-left: 0.3vw;
}
.container .preview-video {
  position: relative;
}
.container .preview-video button {
  position: absolute;
  bottom: 2px;
  background-color: #000;
  outline: 0;
  border: none;
  z-index: 1;
}
.container .enlarge {
  display: inline-block;
  cursor: pointer;
  margin-right: 9px;
}
.container .enlarge svg {
  width: 1vw;
  height: 1vw;
}
.container .enlarge svg:hover {
  -webkit-transform: translate(2px, 0) scale(1.4);
  transform: translate(2px, 0) scale(1.4);
}
.container .header {
  cursor: move;
  background-color: #141b22;
  color: white;
  height: 6%;
  padding-left: 2vw;
  padding-right: 2vw;
}
.container .header .window-buttons {
  margin-top: 0.4vw;
}
.container .header h2 {
  margin: 0;
}
.container .body {
  height: 74%;
  background-color: white;
  padding-left: 2vw;
  padding-right: 2vw;
}
.container .body video,
.container .body .property {
  padding-top: 1vw;
}
.container .body video b,
.container .body .property b {
  width: 7vw;
}
.container .footer {
  height: 20%;
  padding-left: 2vw;
  padding-right: 2vw;
}
.container .footer .start-btn {
  color: white;
}
.container .red {
  background-color: red;
}
.container .blue {
  background-color: blue;
}
.container .preview-ended {
  background-color: black;
  color: white;
  margin: 3vw;
  text-align: center;
}
/*# sourceMappingURL=future-preview.component.css.map */
